import React from "react";
import { Text, Flex, FlexProps, others } from "@chakra-ui/react";

const Link: React.FC<{ text: string; url: string } & FlexProps> = ({ text, url, ...others }) => {
  return (
    <Flex w="100%" h="30px" align="center" {...others}>
      <Text
        as="a"
        href={url}
        target="_blank"
        ml="10%"
        _hover={{ color: "#3fc9a8" }}
        fontSize="14px"
      >
        {text}
      </Text>
    </Flex>
  );
};

export default Link;
